/* Estado global de Boston IA — portado VERBATIM desde boston_ia/index.html.
   La logica original (state mutable + persistencia localStorage + token Sabre)
   se respeta tal cual; solo se agrega un pub/sub minimo para que React re-renderice. */

const STORAGE_KEY = 'boston_scripts_v1'
const CONFIG_KEY = 'boston_config_v1'
const TOKEN_KEY = 'boston_session_token_v1'

export const Storage = {
  loadConfig() {
    try {
      const defaults = defaultConfig()
      const saved = JSON.parse(localStorage.getItem(CONFIG_KEY)) || {}
      const clean = { ...saved }
      delete clean['php' + 'Base']
      delete clean.biaToken
      const legacyFolderPattern = new RegExp('boston_ia[\\\\/]+scripts' + '_ia', 'i')
      if (typeof clean.baseFolder === 'string' && legacyFolderPattern.test(clean.baseFolder)) {
        clean.baseFolder = defaults.baseFolder
      }
      return { ...defaults, ...clean }
    } catch {
      return defaultConfig()
    }
  },
  saveConfig(c) {
    localStorage.setItem(CONFIG_KEY, JSON.stringify(c))
  },
  loadLibrary() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []
    } catch {
      return []
    }
  },
  saveLibrary(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
  },
}

export function defaultConfig() {
  return {
    mode: 'standalone',
    bostonApi: 'https://stg.boston.basset.ws/',
    bostonAkey: 'WrF13sw4H33aj58ZOknBl3PTmc9GQUK518VMir7I',
    baseFolder: 'admin_v2_local_library\\',
    dashboardUrl: '',
  }
}

/* ===== FILE SYSTEM ACCESS (escritura a carpeta del usuario, fallback download) ===== */
export const FsAccess = {
  dirHandle: null,
  async pickDirectory() {
    if (!window.showDirectoryPicker) throw new Error('File System Access API no soportada.')
    this.dirHandle = await window.showDirectoryPicker({ mode: 'readwrite' })
    return this.dirHandle.name
  },
  async write(filename, content) {
    if (this.dirHandle) {
      const fh = await this.dirHandle.getFileHandle(filename, { create: true })
      const w = await fh.createWritable()
      await w.write(content)
      await w.close()
      return true
    }
    const blob = new Blob([content], { type: 'text/typescript' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
    URL.revokeObjectURL(url)
    return false
  },
}

/* ===== ESTADO GLOBAL (mismo modelo que boston_ia) ===== */
export const state = {
  view: 'aiBuild',
  config: Storage.loadConfig(),
  library: Storage.loadLibrary(),
  cs: {
    name: 'mi_script',
    title: 'MI_SCRIPT',
    description: '',
    tags: '',
    uuid: '',
    validateActiveReservation: true,
    sendCommands: false,
    orderExecute: true,
    editCatalogues: false,
    reintentos: 0,
    targetEnv: 'stg',
    forms: [{ form: 'form1', title: 'FORMULARIO', title_visible: true, remarks: [] }],
    postCommands: [],
    raw: null, // data.json completo original (preservacion end-to-end al guardar/publicar)
    handlerJs: null, // app.js del AGENTE 4 (handler de logica dinamica) asociado al script
    fichaMd: null, // FICHA.md (documentacion automatica: riesgo, comandos→APIs, huecos)
  },
  sstSource: '',
  sstProgram: null,
  sstPlan: null,
  sstCs: null,
  consoleHistory: [],
  consoleInput: '',
  remarksPnr: '',
  remarksList: [],
  remarksLoading: false,
  ai: {
    apiKey: '',
    model: (function () {
      try {
        return localStorage.getItem('boston_ai_model_override_v2') || ''
      } catch (e) {
        return ''
      }
    })(),
    systemPrompt: '',
    userPrompt: '',
    lastResult: null,
    lastWarnings: [],
    history: [],
    busy: false,
    imp: {
      files: [],
      importId: '',
      instructions: '',
      interpretation: '',
      interpretationApproved: false,
      busyInterpret: false,
      chat: [],
      busyChat: false,
      lastResult: null,
      logicJson: null,
      converterIr: null,
      conversionMode: '',
      lastWarnings: [],
      lastRawError: null,
      busy: false,
    },
    previewExpanded: false,
    testLog: [],
  },
  apisTab: 'fullres',
  sessionToken: null,
  apisLog: [],
  apisPnr: '',
  apisCarbonPayload: '{"flights":[{"origin":"MEX","destination":"CUN"}]}',
  apisVehPayload: '{"pickUpDate":"2026-05-15","returnDate":"2026-05-18","pickUpLocation":"MEX"}',
  apisBookingPayload: '{"OTA_AirBookRQ":{}}',
  gateway: null,
}

/* ===== TOKEN OPERATIVO: prioridad URL → localStorage → vacio (flujo original) ===== */
;(function initToken() {
  try {
    const u = new URLSearchParams(window.location.search)
    const fromUrl = u.get('token')
    const fromStorage = localStorage.getItem(TOKEN_KEY)
    state.sessionToken = fromUrl || fromStorage || null
    if (fromUrl) {
      try {
        localStorage.setItem(TOKEN_KEY, fromUrl)
      } catch {}
      console.log('[boston] token capturado de URL y persistido')
    } else if (fromStorage) {
      console.log('[boston] token recuperado de localStorage')
    }
  } catch {}
})()

export function setSessionToken(token) {
  state.sessionToken = token ? String(token).trim() : null
  try {
    if (state.sessionToken) localStorage.setItem(TOKEN_KEY, state.sessionToken)
    else localStorage.removeItem(TOKEN_KEY)
  } catch {}
  emit()
}

/* ===== UTILS ===== */
export function uuidV4() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    try {
      return crypto.randomUUID()
    } catch {}
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const escape = (s) =>
  String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')

/* ===== PUB/SUB minimo para React ===== */
const listeners = new Set()
export function subscribe(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
export function emit() {
  listeners.forEach((fn) => {
    try {
      fn()
    } catch (e) {
      console.error('[bostonIA emit]', e)
    }
  })
}

export function saveConfig(partial) {
  state.config = { ...state.config, ...partial }
  Storage.saveConfig(state.config)
  emit()
}

export function saveLibrary(items) {
  state.library = items
  Storage.saveLibrary(items)
  emit()
}
